import OSS from "ali-oss";
export function client() {
  var client = new OSS({
    region: 'oss-cn-beijing', // 北京--区域
    accessKeyId: 'LTAI5tMgiCbpnVnpqhL4hWB2', // 秘钥id
    accessKeySecret: 'zO3c2YPhBW5mcHxZMW7heWXRWaIquE', // 秘钥
    bucket: 'imagecharacter', // 存储桶名称
    secure: true // 上传链接返回支持https
  }) //后端提供数据
  return client
}
